(() => {
  const hydrate = (target) => {
    const card = target.closest('.card-wrapper');
    const image = card?.querySelector('img[data-secondary-src]');
    if (!image || image.dataset.secondaryLoading) return;
    image.dataset.secondaryLoading = 'true';
    image.decoding = 'async';
    image.onload = () => { image.classList.add('is-ready'); image.removeAttribute('data-secondary-src'); image.removeAttribute('data-secondary-srcset'); };
    image.onerror = () => { delete image.dataset.secondaryLoading; };
    image.sizes = image.getAttribute('sizes') || '50vw';
    if (image.dataset.secondarySrcset) image.srcset = image.dataset.secondarySrcset;
    image.src = image.dataset.secondarySrc;
  };
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches) hydrate(event.target);
  }, { passive: true });
  document.addEventListener('focusin', (event) => hydrate(event.target));
})();
